module.exports = __webpack_public_path__ + "img/logo-footer.d7bd8013.png";